import React, { useState, useRef, useEffect } from 'react';
import { getForms } from '../../actions/formActions';
import { listUsers } from '../../actions/userActions';
import { useSelector, useDispatch } from 'react-redux';
import SearchBoxWithListing from '../Common/SearchBoxWithListing';
import { FaPlus } from 'react-icons/fa'; // Importing the plus icon

/*
// Bar
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);




// Line
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend,
  } from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

// Pie
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
ChartJS.register(ArcElement, Tooltip, Legend);

//Doughnut
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
ChartJS.register(ArcElement, Tooltip, Legend);

//PolarArea
import {
  Chart as ChartJS,
  RadialLinearScale,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';
ChartJS.register(RadialLinearScale, ArcElement, Tooltip, Legend);


//Radar
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js';
 ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);


//Scatter
import {
  Chart as ChartJS,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from 'chart.js';
 ChartJS.register(LinearScale, PointElement, LineElement, Tooltip, Legend);


 //Bubble
 import {
  Chart as ChartJS,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
} from 'chart.js';
 ChartJS.register(LinearScale, PointElement, Tooltip, Legend);


 //Chart
 import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController,
} from 'chart.js';
 ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController
);


//Chart Events
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
} from 'chart.js';
import {
  Chart,
  getDatasetAtEvent,
  getElementAtEvent,
  getElementsAtEvent,
} from 'react-chartjs-2';
 ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip
);



//Gradient Chart
import type { ChartData, ChartArea } from 'chart.js';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from 'chart.js';
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend
);
*/

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    RadialLinearScale,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend,
    ArcElement,
    LineController,
    BarController,
} from 'chart.js';

import {
    Bar, Line, Pie, Doughnut, PolarArea, Radar, Scatter, Bubble, Chart,
    getDatasetAtEvent,
    getElementAtEvent,
    getElementsAtEvent,
    ChartData, ChartArea,
} from 'react-chartjs-2';
ChartJS.register(
    PointElement,
    LineElement,
    Filler,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ArcElement,
    RadialLinearScale,
    LineController,
    BarController
);


const Testing = (props) => {

    // const searchBoxKey = "testing_search_form_1";
    // const searchBoxKey = "testing_search_form_2";
    // const searchBoxKey = "testing_search_form_3";
    const searchBoxKey = "testing_search_form_4";
    const listFormKey = "testing_list_form";
    const dispatch = useDispatch();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const userState = useSelector((state) => state.user);
    const formState = useSelector((state) => state.forms);
    const { formJson = {} } = formState;
    const searchBoxJson = formJson[searchBoxKey] || {};
    const { listing = {} } = userState;
    const { data = {} } = searchBoxJson;
    const { section = [] } = data;
    const [firstSection = {}] = section;
    const { fields = [] } = firstSection;
    const addIconField = fields.filter(field => field.id == 'addIcon');
    const showAddIcon = addIconField.length > 0;
    const [{ label = '' } = {}] = addIconField;

    const actionsHandling = (action, rowData) => {
        console.log("Action = ", action, rowData);
    }

    const listApi = (data) => {
        return dispatch(listUsers(data, listFormKey));
    }

    const handleAdd = () => {
        alert('Yet to implement');
        setIsModalOpen(true);
    }



    const verticalBar_options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Vertical Bar',
            },
        },
    };
    const verticalBar_labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
    const verticalBar_data = {
        labels: verticalBar_labels,
        datasets: [
            {
                label: 'Dataset 1',
                data: verticalBar_labels.map((key, index) => (index * Math.random())),
                backgroundColor: 'rgba(255, 99, 132, 0.5)',
            },
            {
                label: 'Dataset 2',
                data: verticalBar_labels.map((key, index) => (index * Math.random())),
                backgroundColor: 'rgba(53, 162, 235, 0.5)',
            },
        ],
    };


    const horizontalBar_options = {
        indexAxis: 'y',
        elements: {
            bar: {
                borderWidth: 2,
            },
        },
        responsive: true,
        plugins: {
            legend: {
                position: 'right',
            },
            title: {
                display: true,
                text: 'Chart.js Horizontal Bar Chart',
            },
        },
    };
    const horizontalBar_labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
    const horizontalBar_data = {
        labels: horizontalBar_labels,
        datasets: [
            {
                label: 'Dataset 1',
                data: horizontalBar_labels.map((key, index) => (index * Math.random())),
                borderColor: 'rgb(255, 99, 132)',
                backgroundColor: 'rgba(255, 99, 132, 0.5)',
            },
            {
                label: 'Dataset 2',
                data: horizontalBar_labels.map((ket, index) => (index * Math.random())),
                borderColor: 'rgb(53, 162, 235)',
                backgroundColor: 'rgba(53, 162, 235, 0.5)',
            },
        ],
    };



    const stackedBar_options = {
        plugins: {
            title: {
                display: true,
                text: 'Chart.js Bar Chart - Stacked',
            },
        },
        responsive: true,
        scales: {
            x: {
                stacked: true,
            },
            y: {
                stacked: true,
            },
        },
    };
    const stackedBar_labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
    const stackedBar_data = {
        labels: stackedBar_labels,
        datasets: [
            {
                label: 'Dataset 1',
                data: stackedBar_labels.map((key, index) => (index * Math.random())),
                backgroundColor: 'rgb(255, 99, 132)',
            },
            {
                label: 'Dataset 2',
                data: stackedBar_labels.map((key, index) => (index * Math.random())),
                backgroundColor: 'rgb(75, 192, 192)',
            },
            {
                label: 'Dataset 3',
                data: stackedBar_labels.map((key, index) => (index * Math.random())),
                backgroundColor: 'rgb(53, 162, 235)',
            },
        ],
    };



    const groupedBar_options = {
        plugins: {
            title: {
                display: true,
                text: 'Chart.js Bar Chart - Stacked',
            },
        },
        responsive: true,
        interaction: {
            mode: 'index',
            intersect: false,
        },
        scales: {
            x: {
                stacked: true,
            },
            y: {
                stacked: true,
            },
        },
    };
    const groupedBar_labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
    const groupedBar_data = {
        labels: groupedBar_labels,
        datasets: [
            {
                label: 'Dataset 1',
                data: groupedBar_labels.map((key, index) => (index * Math.random())),
                backgroundColor: 'rgb(255, 99, 132)',
                stack: 'Stack 0',
            },
            {
                label: 'Dataset 2',
                data: groupedBar_labels.map((key, index) => (index * Math.random())),
                backgroundColor: 'rgb(75, 192, 192)',
                stack: 'Stack 0',
            },
            {
                label: 'Dataset 3',
                data: groupedBar_labels.map((key, index) => (index * Math.random())),
                backgroundColor: 'rgb(53, 162, 235)',
                stack: 'Stack 1',
            },
        ],
    };



    const area_options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Chart.js Line Chart',
            },
        },
    };
    const area_labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
    const area_data = {
        labels: area_labels,
        datasets: [
            {
                fill: true,
                label: 'Dataset 2',
                data: area_labels.map((k, index) => (index * Math.random())),
                borderColor: 'rgb(53, 162, 235)',
                backgroundColor: 'rgba(53, 162, 235, 0.5)',
            },
        ],
    };



    const line_options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Chart.js Line Chart',
            },
        },
    };
    const line_labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
    const line_data = {
        labels: line_labels,
        datasets: [
            {
                label: 'Dataset 1',
                data: line_labels.map((k, index) => (index * Math.random())),
                borderColor: 'rgb(255, 99, 132)',
                backgroundColor: 'rgba(255, 99, 132, 0.5)',
            },
            {
                label: 'Dataset 2',
                data: line_labels.map((k, index) => (index * Math.random())),
                borderColor: 'rgb(53, 162, 235)',
                backgroundColor: 'rgba(53, 162, 235, 0.5)',
            },
        ],
    };



    const multiaxisLine_options = {
        responsive: true,
        interaction: {
            mode: 'index',
            intersect: false,
        },
        stacked: false,
        plugins: {
            title: {
                display: true,
                text: 'Chart.js Line Chart - Multi Axis',
            },
        },
        scales: {
            y: {
                type: 'linear',
                display: true,
                position: 'left',
            },
            y1: {
                type: 'linear',
                display: true,
                position: 'right',
                grid: {
                    drawOnChartArea: false,
                },
            },
        },
    };
    const multiaxisLine_labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
    const multiaxisLine_data = {
        labels: multiaxisLine_labels,
        datasets: [
            {
                label: 'Dataset 1',
                data: multiaxisLine_labels.map((k, i) => (i * Math.random())),
                borderColor: 'rgb(255, 99, 132)',
                backgroundColor: 'rgba(255, 99, 132, 0.5)',
                yAxisID: 'y',
            },
            {
                label: 'Dataset 2',
                data: multiaxisLine_labels.map((k, i) => (i * 150 + i * Math.random())),
                borderColor: 'rgb(53, 162, 235)',
                backgroundColor: 'rgba(53, 162, 235, 0.5)',
                yAxisID: 'y1',
            },
        ],
    };



    const pie_data = {
        labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
        datasets: [
            {
                label: '# of Votes',
                data: [12, 19, 3, 5, 2, 3],
                backgroundColor: [
                    'rgba(255, 99, 132, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                    'rgba(255, 206, 86, 0.2)',
                    'rgba(75, 192, 192, 0.2)',
                    'rgba(153, 102, 255, 0.2)',
                    'rgba(255, 159, 64, 0.2)',
                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(75, 192, 192, 1)',
                    'rgba(153, 102, 255, 1)',
                    'rgba(255, 159, 64, 1)',
                ],
                borderWidth: 1,
            },
        ],
    };



    const doughnut_data = {
        labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
        datasets: [
            {
                label: '# of Votes',
                data: [12, 19, 3, 5, 2, 3],
                backgroundColor: [
                    'rgba(255, 99, 132, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                    'rgba(255, 206, 86, 0.2)',
                    'rgba(75, 192, 192, 0.2)',
                    'rgba(153, 102, 255, 0.2)',
                    'rgba(255, 159, 64, 0.2)',
                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(75, 192, 192, 1)',
                    'rgba(153, 102, 255, 1)',
                    'rgba(255, 159, 64, 1)',
                ],
                borderWidth: 1,
            },
        ],
    };



    const polarArea_data = {
        labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
        datasets: [
            {
                label: '# of Votes',
                data: [12, 19, 3, 5, 2, 3],
                backgroundColor: [
                    'rgba(255, 99, 132, 0.5)',
                    'rgba(54, 162, 235, 0.5)',
                    'rgba(255, 206, 86, 0.5)',
                    'rgba(75, 192, 192, 0.5)',
                    'rgba(153, 102, 255, 0.5)',
                    'rgba(255, 159, 64, 0.5)',
                ],
                borderWidth: 1,
            },
        ],
    };



    const radar_data = {
        labels: ['Thing 1', 'Thing 2', 'Thing 3', 'Thing 4', 'Thing 5', 'Thing 6'],
        datasets: [
            {
                label: '# of Votes',
                data: [2, 9, 3, 5, 2, 3],
                backgroundColor: 'rgba(255, 99, 132, 0.2)',
                borderColor: 'rgba(255, 99, 132, 1)',
                borderWidth: 1,
            },
        ],
    };



    const scatter_options = {
        scales: {
            y: {
                beginAtZero: true,
            },
        },
    };
    const scatter_data = {
        datasets: [
            {
                label: 'A dataset',
                data: Array.from({ length: 100 }, (k, i) => ({
                    x: i * Math.random() + i * 1,
                    y: i * Math.random() + i * -4,
                })),
                backgroundColor: 'rgba(255, 99, 132, 1)',
            },
        ],
    };



    const bubble_options = {
        scales: {
            y: {
                beginAtZero: true,
            },
        },
    };
    const bubble_data = {
        datasets: [
            {
                label: 'Red dataset',
                data: Array.from({ length: 50 }, (k, i) => ({
                    x: Math.random() * i,
                    y: Math.random() * i,
                    r: Math.random() * 0.1 * i,
                })),
                backgroundColor: 'rgba(255, 99, 132, 0.5)',
            },
            {
                label: 'Blue dataset',
                data: Array.from({ length: 50 }, (k, i) => ({
                    x: Math.random() * i,
                    y: Math.random() * i,
                    r: Math.random() * 0.1 * i,
                })),
                backgroundColor: 'rgba(53, 162, 235, 0.5)',
            },
        ],
    };



    const multiTypeChart_labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
    const multiTypeChart_data = {
        labels: multiTypeChart_labels,
        datasets: [
            {
                type: 'line',
                label: 'Dataset 1',
                borderColor: 'rgb(255, 99, 132)',
                borderWidth: 2,
                fill: false,
                data: multiTypeChart_labels.map((k, i) => (Math.random() * i)),
            },
            {
                type: 'bar',
                label: 'Dataset 2',
                backgroundColor: 'rgb(75, 192, 192)',
                data: multiTypeChart_labels.map((k, i) => (Math.random() * i)),
                borderColor: 'white',
                borderWidth: 2,
            },
            {
                type: 'bar',
                label: 'Dataset 3',
                backgroundColor: 'rgb(53, 162, 235)',
                data: multiTypeChart_labels.map((k, i) => (Math.random() * i)),
            },
        ],
    };



    const chartEvent_options = {
        scales: {
            y: {
                beginAtZero: true,
            },
        },
    };
    const chartEvent_labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
    const chartEvent_data = {
        labels: chartEvent_labels,
        datasets: [
            {
                type: 'line',
                label: 'Dataset 1',
                borderColor: 'rgb(255, 99, 132)',
                borderWidth: 2,
                fill: false,
                data: chartEvent_labels.map((k, i) => (Math.random() * i)),
            },
            {
                type: 'bar',
                label: 'Dataset 2',
                backgroundColor: 'rgb(75, 192, 192)',
                data: chartEvent_labels.map((k, i) => (Math.random() * i)),
                borderColor: 'white',
                borderWidth: 2,
            },
            {
                type: 'bar',
                label: 'Dataset 3',
                backgroundColor: 'rgb(53, 162, 235)',
                data: chartEvent_labels.map((k, i) => (Math.random() * i)),
            },
        ],
    };
    const printDatasetAtEvent = (dataset) => {
        if (!dataset.length) return;
        const datasetIndex = dataset[0].datasetIndex;
        console.log(chartEvent_data.datasets[datasetIndex].label);
    };
    const printElementAtEvent = (element) => {
        if (!element.length) return;
        const { datasetIndex, index } = element[0];
        console.log(chartEvent_data.labels[index], chartEvent_data.datasets[datasetIndex].data[index]);
    };
    const printElementsAtEvent = (elements) => {
        if (!elements.length) return;
        console.log(elements.length);
    };
    const chartRef = useRef(null);
    const onClick = (event) => {
        const { current: chart } = chartRef;
        if (!chart) {
            return;
        }
        printDatasetAtEvent(getDatasetAtEvent(chart, event));
        printElementAtEvent(getElementAtEvent(chart, event));
        printElementsAtEvent(getElementsAtEvent(chart, event));
    };



    useEffect(() => {
        const chart = chartRef.current;
        triggerTooltip(chart);
    }, []);
    const chartRef_1 = useRef(null);
    const chartRef_labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
    const chartRef_data = {
        labels: chartRef_labels,
        datasets: [
            {
                type: 'line',
                label: 'Dataset 1',
                borderColor: 'rgb(255, 99, 132)',
                borderWidth: 2,
                fill: false,
                data: chartRef_labels.map((k, i) => (Math.random() * 100)),
            },
            {
                type: 'bar',
                label: 'Dataset 2',
                backgroundColor: 'rgb(75, 192, 192)',
                data: chartRef_labels.map((k, i) => (Math.random() * 100)),
                borderColor: 'white',
                borderWidth: 2,
            },
            {
                type: 'bar',
                label: 'Dataset 3',
                backgroundColor: 'rgb(53, 162, 235)',
                data: chartRef_labels.map((k, i) => (Math.random() * 100)),
            },
        ],
    };
    function triggerTooltip(chart) {
        const tooltip = chart?.tooltip;
        if (!tooltip) {
            return;
        }
        if (tooltip.getActiveElements().length > 0) {
            tooltip.setActiveElements([], { x: 0, y: 0 });
        } else {
            const { chartArea } = chart;
            tooltip.setActiveElements(
                [
                    {
                        datasetIndex: 0,
                        index: 2,
                    },
                    {
                        datasetIndex: 1,
                        index: 2,
                    },
                ],
                {
                    x: (chartArea.left + chartArea.right) / 2,
                    y: (chartArea.top + chartArea.bottom) / 2,
                }
            );
        }
        chart.update();
    }



    /*
    const gradientChart_labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
    const gradientChart_colors = [
        'red',
        'orange',
        'yellow',
        'lime',
        'green',
        'teal',
        'blue',
        'purple',
    ];
    const gradientChart_data = {
        gradientChart_labels,
        datasets: [
            {
                label: 'Dataset 1',
                data: gradientChart_labels.map((k, i) => i * Math.random() * 10),
            },
            {
                label: 'Dataset 2',
                data: gradientChart_labels.map((k, i) => i * Math.random() * 10),
            },
        ],
    };
    function createGradient(ctx, area) {
        const colorStart = gradientChart_colors[Math.random() % 8];
        const colorMid = faker.random.arrayElement(
            colors.filter(color => color !== colorStart)
        );
        const colorEnd = faker.random.arrayElement(
            colors.filter(color => color !== colorStart && color !== colorMid)
        );

        const gradient = ctx.createLinearGradient(0, area.bottom, 0, area.top);

        gradient.addColorStop(0, colorStart);
        gradient.addColorStop(0.5, colorMid);
        gradient.addColorStop(1, colorEnd);

        return gradient;
    }*/

    return (
        <div style={{ position: 'relative', paddingBottom: showAddIcon ? '80px' : '0px' }}> {/* Added padding-bottom */}
            <SearchBoxWithListing
                searchBoxKey={searchBoxKey}
                listFormKey={listFormKey}
                fetchForm={getForms}
                listApi={listApi}
                searchBoxJson={searchBoxJson}
                listingData={listing}
                actionsHandling={actionsHandling}
            />

            {/* Floating Add Button */}
            {showAddIcon ? <div
                onClick={() => handleAdd()}
                style={{
                    position: 'fixed',
                    bottom: '20px',
                    right: '20px',
                    backgroundColor: 'green',
                    color: 'white',
                    borderRadius: '50%',
                    padding: '15px',
                    cursor: 'pointer',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                    zIndex: 1000,
                }}
                title={label}
            >
                <FaPlus size={20} />
            </div> : ''}


            <div className="row">
                <div className="col-md-6">
                    <Bar options={verticalBar_options} data={verticalBar_data} />
                </div>
                <div className="col-md-6">
                    <Bar options={horizontalBar_options} data={horizontalBar_data} />
                </div>
                <div className="col-md-6">
                    <Bar options={stackedBar_options} data={stackedBar_data} />
                </div>
                <div className="col-md-6">

                    <Bar options={groupedBar_options} data={groupedBar_data} />
                </div>
                <div className="col-md-6">
                    <Line options={area_options} data={area_data} />
                </div>
                <div className="col-md-6">
                    <Line options={line_options} data={line_data} />
                </div>
                <div className="col-md-6">
                    <Line options={multiaxisLine_options} data={multiaxisLine_data} />
                </div>
                <div className="col-md-6">
                    <Pie data={pie_data} />
                </div>
                <div className="col-md-6">
                    <Doughnut data={doughnut_data} />
                </div>
                <div className="col-md-6">
                    <PolarArea data={polarArea_data} />
                </div>
                <div className="col-md-6">
                    <Radar data={radar_data} />
                </div>
                <div className="col-md-6">
                    <Scatter options={scatter_options} data={scatter_data} />
                </div>
                <div className="col-md-6">
                    <Bubble options={bubble_options} data={bubble_data} />
                </div>
                <div className="col-md-6">
                    <Chart type='bar' data={multiTypeChart_data} />
                </div>

                <div className="col-md-6">
                    <Chart
                        ref={chartRef}
                        type='bar'
                        onClick={onClick}
                        options={chartEvent_options}
                        data={chartEvent_data}
                    />
                </div>
                <div className="col-md-6">
                    <Chart ref={chartRef_1} type='bar' data={chartRef_data} />;
                </div>
            </div>

        </div>
    );
};

export default Testing;
